import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import Typo from './Typo'
import classNames from 'classnames'

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        columnGap: '12px',
        flexWrap: 'wrap',
        rowGap: '.5rem',
    },
    inputRadio: {
        height: '24px',
        width: '24px',
        accentColor: '#FF4F21',
        cursor: 'pointer'
    },
    inputRadioSafari: {
        height: '15px',
        width: '15px',
        accentColor: '#FF4F21',
        cursor: 'pointer'
    },
    label: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
        color: '#000648',
        maxWidth: '85%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    labelChecked: {
        fontWeight: 700,
    },
    '@media (max-width: 1000px)': {
        inputRadio: {
            height: '20px',
            width: '20px',
            accentColor: '#FF4F21'
        },
    }
})
function RadioButton({
    name,
    value,
    onChange,
    label,
    onClick,
    checked,
    defaultChecked,
    className,
    labelClassName,
}) {
    const classes = useStyles()
    var isNotSafari;

    // Check if the browser is Safari
    if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
        isNotSafari = false
    } else {
        isNotSafari = true
    }

    // Typo data memoization
    const typoData = useMemo(() => {
        const typoList = [
            { label, className: `${classes.label} ${checked ? classes.labelChecked : ''}`, variant: 'pp08' }
        ];
        if (label === 'Clamp Kiosk') {
            typoList.push({
                label: '(Recommended for food trucks)',
                variant: 'pp17'
            });
        }
        return typoList;
    }, [label, checked, classes.label, classes.labelChecked]);

    return (
        <div className={classNames(classes.root, className)}>
            <input
                onClick={onClick}
                type="radio"
                name={name}
                value={value}
                onChange={onChange}
                className={isNotSafari ? classes.inputRadio : classes.inputRadioSafari}
                checked={checked}
                defaultChecked={defaultChecked}
            />  
            {typoData.map((typo, index) => (
                <Typo
                    key={index}
                    variant={typo.variant || 'pp08'}
                    className={classNames(typo.className, labelClassName)}
                >
                    {typo.label}
                </Typo>
            ))}
        </div>
    )
}

RadioButton.propTypes = {
    name: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    label: PropTypes.string,
    checked: PropTypes.bool,
}

export default RadioButton
